import { Formik } from 'formik';
import {
  Divider,
  Grid,
  MenuItem,
  TextField,
  Select,
  InputLabel,
  FormControl,
} from '@material-ui/core';
import { normalize, schema } from 'normalizr';
import { toTitleCase } from 'Utils';
import { Redirect } from 'react-router-dom';
import Error from 'Components/Error';
import ErrorNotification from 'Components/ErrorNotification';
import Loader from 'Components/Loader';
import React from 'react';

import AddPhoto from './components/AddPhoto';
import AddSpecifications from './components/AddSpecifications';
import AddAttachment from './components/AddAttachment';
import API from './api';
import ContactDetails from './components/ContactDetails';
import Container from './components/Container';
import IESUpload from './components/IESUpload';
import IssuedBy from './components/IssuedBy';
import CountryProject from './components/CountryProject';
import NoteAndUrl from './components/NoteAndUrl';
import PhotosAndNotes from './components/PhotosAndNotes';
import Section from './components/Section';
import SendSlip from './components/SendSlip';
import SettingsGrid from './components/SettingsGrid';
import SettingsItem from './components/SettingsItem';
import ticketMachine from './stateMachine';
import TicketReference from './components/TicketReference';
import makeSchema from './validationSchema';
import InfoText from './components/InfoText';
import Supply from '../../';
import moment from 'moment';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';
import SelectCustom from '../../../../../components/demand/Demand/screens/CETicket/components/SelectCustom/index';
import { countries } from './countries';

const HeaderGrid = styled(Grid)`
  padding-bottom: ${rhythm(0.5)};
`;

const UpdateMsg = styled.div`
  color: #f44336;
  padding: ${rhythm(0.5)} 0;
  max-width: 1024px;
  text-align: justify;
  font-weight: 600;
  font-size: 1rem;
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100% !important;
  align-items: flex-start !important;
  justify-content: space-between !important;
`;

const CustomText = styled.h4`
  margin-bottom: 0 !important;
`;

class TicketView extends React.PureComponent {
  photo = React.createRef();
  photo1 = React.createRef();
  specificationRef = React.createRef();
  attachmentRef = React.createRef();
  iesInputRef = React.createRef();

  state = {
    photo: null,
    photo1: null,
    viewState: ticketMachine.initial,
    errors: null,
    criteria: null,
    locationOnPlan: '',
    projectInfo: null,
    circularEconomy: [],
    menuQuestions: {},
    multipleQuestions: {},
    generatedTextField: false,
    generatedTextValues: {},
    multipleQuestionsId: [],
    textFieldValues: {},
  };

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.onGetTicket();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.ticketId !== this.props.match.params.ticketId) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.onGetTicket();
    }
  }

  onGetTicket = () => {
    if (this.state.viewState !== 'loading') {
      return this.setState(
        (state, props) => ({
          ...state,
          viewState: ticketMachine.initial,
        }),
        this.getTicket
      );
    }
    return this.getTicket();
  };

  getTicket = () => {
    const { ticketId } = this.props.match.params;
    API.getTicket(ticketId)
      .then(res => {
        const { criteria, ...rest } = res.data;
        const normalized = this.normalizeData(criteria);
        let questionsObject = {};
        let multipleObject = {};
        let textBoxValues = {};

        let mappedQuestions = [];
        let mappedMultipleQuestions = [];
        let mappedAnswers = [];
        let mappedTextBoxQuestions = [];

        let generatedTextValuesLocal = {};
        if (res.data.circularEconomy) {
          mappedQuestions = res.data.circularEconomy.map(item =>
            item.questions
              .filter(question => question.questionType === 'PULL_DOWN_MENU')
              .map(question => question.id)
          );
          if (mappedQuestions) {
            let questions = [];
            questions = questions.concat.apply([], mappedQuestions);
            questionsObject = questions.reduce((acc, elem) => {
              acc[elem] = 9999;
              return acc;
            }, {});
          }

          mappedMultipleQuestions = res.data.circularEconomy.map(item =>
            item.questions
              .filter(
                question =>
                  question.questionType === 'PULL_DOWN_MENU_MULTISELECT'
              )
              .map(question => question.id)
          );

          if (mappedMultipleQuestions) {
            let questions = [];
            questions = questions.concat.apply([], mappedMultipleQuestions);
            multipleObject = questions.reduce((acc, elem) => {
              acc[elem] = [];
              return acc;
            }, {});
          }

          mappedAnswers = res.data.circularEconomy.map(item =>
            item.questions.map(question =>
              question.answers
                .filter(filter => filter.answerType === 'SELECT_TEXTBOX')
                .map(answer => answer.id)
            )
          );

          if (mappedAnswers) {
            let answers = [];
            answers = answers.concat.apply([], mappedAnswers);
            generatedTextValuesLocal = answers.reduce((acc, elem) => {
              acc[elem] = '';
              return acc;
            }, {});
          }

          mappedTextBoxQuestions = res.data.circularEconomy.map(item =>
            item.questions
              .filter(question => question.questionType === 'DIRECT')
              .map(question => question.answers.map(answer => answer.id))
          );

          if (mappedTextBoxQuestions) {
            let answers = [];
            let slicedAnswers = [];
            answers = answers.concat.apply([], mappedTextBoxQuestions);
            for (let i = 0; i < answers.length; i++) {
              for (let j = 0; j < answers[i].length; j++) {
                slicedAnswers.push([answers[i][j]]);
              }
            }
            textBoxValues = slicedAnswers.reduce((acc, elem) => {
              acc[elem] = '';
              return acc;
            }, {});
          }
        }

        this.setState(prevState => {
          return {
            ...prevState,
            criteria: {
              ...rest,
              ...normalized,
            },
            viewState: ticketMachine.transition(prevState.viewState, 'DATA')
              .value,
            locationOnPlan: res.data.locationOnPlan,
            projectInfo: res.data.projectInfo,
            circularEconomy: res.data.circularEconomy,
            menuQuestions: { ...questionsObject },
            multipleQuestions: { ...multipleObject },
            generatedTextValues: { ...generatedTextValuesLocal },
            textFieldValues: { ...textBoxValues },
          };
        });
      })
      .catch(err => {
        this.setState(prevState => ({
          ...prevState,
          errors: err,
          viewState: ticketMachine.transition(prevState.viewState, 'ERROR')
            .value,
        }));
      });
  };
  normalizeData = data => {
    const node = new schema.Entity('criteria');
    node.define({
      criteria: [node],
    });
    const treeSchema = [node];

    const normalized = normalize(data, treeSchema);

    return {
      entities: normalized.entities.criteria,
      result: normalized.result,
    };
  };

  handleItemName = name => {
    const nameWords = name.split(' ');
    if (nameWords.length === 1) {
      return name;
    }
    return nameWords
      .map((word, i) => {
        if (i === 0) return word;
        return toTitleCase(word);
      })
      .join('');
  };

  onUrlAndNoteChange = setFieldValue => type => e => {
    setFieldValue(type, e.target.value);
  };

  onAddPhoto = setFieldValue => e => {
    const inputName = e.target.getAttribute('name');
    if (this[inputName].current.files && this[inputName].current.files[0]) {
      if (this[inputName].current.files[0].size > 5242880) {
        this[inputName].current.value = '';
        return this.setState(state => {
          return {
            ...state,
            viewState: ticketMachine.transition(
              state.viewState,
              'PHOTO_SIZE_ERROR'
            ).value,
          };
        });
      }
      const reader = new FileReader();
      reader.onload = e => {
        this.setState(prevState => {
          return {
            ...prevState,
            [inputName]: e.target.result,
          };
        }, setFieldValue(inputName, this[inputName].current.files[0]));
      };
      reader.readAsDataURL(this[inputName].current.files[0]);
    }
  };

  onClearImage = setFieldValue => photo => () => {
    this.setState(
      {
        [photo]: null,
      },
      setFieldValue(photo, null)
    );
  };

  onAddSpecification = (setFieldValue, specificationSheets) => () => {
    if (specificationSheets.length >= 3) return;
    if (
      this.specificationRef.current.files &&
      this.specificationRef.current.files[0]
    ) {
      if (this.specificationRef.current.files[0].size > 5242880) {
        this.specificationRef.current.value = '';
        return this.setState(state => {
          return {
            ...state,
            viewState: ticketMachine.transition(
              state.viewState,
              'SPEC_SIZE_ERROR'
            ).value,
          };
        });
      }
      setFieldValue('specificationSheets', [
        ...specificationSheets,
        this.specificationRef.current.files[0],
      ]);
    }
  };
  onAddAttachment = (setFieldValue, values) => attach => () => {
    if (
      this.attachmentRef.current.files &&
      this.attachmentRef.current.files[0]
    ) {
      if (this.attachmentRef.current.files[0].size > 5242880) {
        this.attachmentRef.current.value = '';
        return this.setState(state => {
          return {
            ...state,
            viewState: ticketMachine.transition(
              state.viewState,
              'ATTACH_SIZE_ERROR'
            ).value,
          };
        });
      }
      setFieldValue(attach, this.attachmentRef.current.files[0]);
    }
  };

  onClearValue = setFieldValue => type => () => {
    setFieldValue(type, null);
    // clears a ref to enable uploading again
    this.iesInputRef.current.value = '';
  };

  onSpecificationRemove = (
    setFieldValue,
    specificationSheets
  ) => index => () => {
    const filtered = specificationSheets.filter((sheet, i) => {
      return i !== index;
    });

    setFieldValue('specificationSheets', filtered);
    // clears a ref to enable uploading again
    this.specificationRef.current.value = '';
  };

  onAttachmentRemove = (setFieldValue, values) => index => () => {
    setFieldValue(`attachmentFile${index}`, null);
    // clears a ref to enable uploading again
    this.attachmentRef.current.value = '';
  };

  onAddIESFile = setFieldValue => () => {
    if (this.iesInputRef.current.files && this.iesInputRef.current.files[0]) {
      if (this.iesInputRef.current.files[0].size > 5242880) {
        this.iesInputRef.current.value = '';
        return this.setState(state => {
          return {
            ...state,
            viewState: ticketMachine.transition(
              state.viewState,
              'IES_SIZE_ERROR'
            ).value,
          };
        });
      }
      setFieldValue('ies', this.iesInputRef.current.files[0]);
    }
  };

  onErrorCancel = () => {
    this.setState(prevState => ({
      errors: null,
      viewState: ticketMachine.transition(prevState.viewState, 'CANCEL').value,
    }));
  };

  onRetry = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        viewState: ticketMachine.initial,
      };
    }, this.getTicket);
  };

  removeWhiteSpace(string) {
    let str;
    str = string.split('.').join('');
    return str.replace(/ /g, '_');
  }

  makeInitialValues(data) {
    if (!data) return;
    let initialState = {
      photo: null,
      photo1: null,
      attachmentFile1: null,
      attachmentFile2: null,
      attachmentFile3: null,
      attachmentFile4: null,
      attachmentFile5: null,
      attachmentFile6: null,
      attachmentFile7: null,
      specificationSheets: [],
      url: '',
      slipNote: '',
      ies: null,
    };
    const { result, entities } = data;

    for (let prop in result) {
      for (let criteria in entities[result[prop]].criteria) {
        const name = this.removeWhiteSpace(
          `${entities[result[prop]].name}_${
            entities[entities[result[prop]].criteria[criteria]].name
          }`
        );
        initialState[name] = false;
      }
    }
    return initialState;
  }

  renderDesc(criteria) {
    if (!criteria || !criteria.length) return '';
    return criteria.map(id => {
      const { name, value, unit } = this.state.criteria.entities[id];
      if (name && !value) {
        return `${name} `;
      }
      if (name && value) {
        if (
          id === 132 ||
          id === 389 ||
          id === 270 ||
          id === 318 ||
          id === 319 ||
          id === 320 ||
          id === 321 ||
          id === 322 ||
          id === 323 ||
          id === 324 ||
          id === 325 ||
          id === 391 ||
          id === 330 ||
          id === 1304 ||
          id === 261
        ) {
          if (unit === null) {
            return `${value}`;
          } else {
            return `${value}${unit !== null ? ' ' + unit : ''} `;
          }
        } else {
          if (id === 326 || id === 327 || id === 329) {
            return `${name} ${value}${unit !== null ? ' ' + unit : ''} `;
          } else if (
            id === 63 ||
            id === 111 ||
            id === 261 ||
            id === 328 ||
            id === 65
          ) {
            return `${name} ${value}${unit !== null ? ' ' + unit : ''} `;
          } else if (id === 376 || id === 331) {
            return `${value}${unit !== null ? ' ' + unit : ''} `;
          } else if (id === 568) {
            return name + value + unit;
          } else {
            return `${name}: ${value}${unit !== null ? ' ' + unit : ''} `;
          }
        }
      }
      return '';
    });
  }

  renderCriteria = ({ handleChange, handleBlur, values, errors, touched }) => {
    if (!this.state.criteria) return null;
    return this.state.criteria.result.map(id => {
      const name = this.state.criteria.entities[id].name;
      return (
        <Section key={id} name={toTitleCase(name)}>
          <SettingsGrid>
            {this.state.criteria.entities[id].criteria.map(criteriaId => {
              const nameAtr = this.removeWhiteSpace(
                `${this.state.criteria.entities[id].name}_${this.state.criteria.entities[criteriaId].name}`
              );
              return (
                <SettingsItem
                  key={criteriaId}
                  error={
                    errors[nameAtr] && touched[nameAtr] ? errors[nameAtr] : null
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name={nameAtr}
                  value={String(values[nameAtr])}
                  title={this.state.criteria.entities[criteriaId].name}
                  desc={this.renderDesc(
                    this.state.criteria.entities[criteriaId].criteria
                  )}
                />
              );
            })}
          </SettingsGrid>
        </Section>
      );
    });
  };

  createSlip = (ticketId, data, fetchTickets) => () => {
    API.createSlip(ticketId, data)
      .then(res => {
        if (res.status === 200) {
          this.setState(
            prevState => {
              return {
                ...prevState,
                viewState: ticketMachine.transition(prevState.viewState, 'SLIP')
                  .value,
              };
            },
            // fetchTickets,
            () => {
              this.props.history.push({
                pathname: '/supply',
                state: { slipCreated: true },
              });
            }
          );
        }
      })
      .catch(err => {
        this.setState(prevState => ({
          ...prevState,
          errors: err,
          viewState: ticketMachine.transition(prevState.viewState, 'ERROR')
            .value,
        }));
      });
  };

  onCreateSlip = fetchTickets => values => {
    const data = new FormData();
    const { ticketId } = this.props.match.params;
    let url = btoa(encodeURI(values.url));
    let note = btoa(encodeURI(values.slipNote));
    data.append('url', url);
    if (values.photo !== null) {
      data.append('image1', values.photo);
    }
    if (values.photo1 !== null) {
      data.append('image2', values.photo1);
    }

    let i;
    for (i = 1; i < 8; i++) {
      if (
        values[`attachmentFile${i}`] &&
        !values[`attachmentFile${i}`].assetId
      ) {
        data.append(`attachmentFile${i}`, values[`attachmentFile${i}`]);
      } else if (
        values[`attachmentFile${i}`] &&
        values[`attachmentFile${i}`].assetId
      ) {
        data.append(
          `attachmentFile${i}Id`,
          values[`attachmentFile${i}`].assetId
        );
      } else {
        data.append(`attachmentFile${i}Id`, '');
      }
    }

    for (let prop in values.specificationSheets) {
      data.append(`file${Number(prop) + 1}`, values.specificationSheets[prop]);
    }
    if (values.ies !== null) {
      data.append('ies', values.ies);
    }

    if (values.slipNote !== '') {
      data.append('slipNote', note);
    }
    let answers = Object.values(this.state.menuQuestions);
    let multipleAnswers = this.state.multipleQuestionsId;
    let generatedText = this.state.generatedTextValues;
    let textFieldAnswers = this.state.textFieldValues;
    // data.set('slipNote', values.slipNote);
    let index = 0;
    for (let a = 0; a < answers.length; a++) {
      if (answers[a] !== 9999) {
        data.append(`answers[${index}].answerId`, answers[a]);
        index++;
      }
    }
    for (let a = 0; a < multipleAnswers.length; a++) {
      if (multipleAnswers[a] !== 9999) {
        data.append(`answers[${index}].answerId`, multipleAnswers[a]);
        if (multipleAnswers[a] === '10') {
          data.append(`answers[${index}].value`, generatedText[10]);
        }
        index++;
      }
    }
    for (let a = 0; a < Object.values(textFieldAnswers).length; a++) {
      if (Object.entries(textFieldAnswers)[a][1] !== '') {
        data.append(
          `answers[${index}].answerId`,
          Object.entries(textFieldAnswers)[a][0]
        );
        data.append(
          `answers[${index}].value`,
          Object.entries(textFieldAnswers)[a][1]
        );
        index++;
      }
    }

    this.setState(
      prevState => ({
        ...prevState,
        photo: null,
        photo1: null,
        viewState: ticketMachine.initial,
      }),
      this.createSlip(ticketId, data, fetchTickets)
    );
  };

  onFileSizeErrorCancel = () => {
    this.setState(state => ({
      ...state,
      viewState: ticketMachine.transition(state.viewState, 'CANCEL').value,
    }));
  };

  renderSlipOptions = values => {
    let checked = values;
    delete checked.ies;
    delete checked.specificationSheets;
    delete checked.slipNote;
    delete checked.photo;
    delete checked.photo1;
    delete checked.url;
    let allTrue = Object.keys(checked).every(function(k) {
      return checked[k];
    });

    return allTrue;
  };

  handleQuestions = (event, id, type, answerType, answerId) => {
    if (type === 'singleSelect') {
      this.setState(prevState => ({
        menuQuestions: {
          ...prevState.menuQuestions,
          [id]: event.target.value,
        },
      }));
    }
    if (type === 'multipleSelect') {
      if (answerType === 'SELECT_TEXTBOX') {
        this.generateTextField(answerType, answerId);
      }
      const index = this.state.multipleQuestionsId.findIndex(
        stationId => stationId === answerId
      );
      const tempArray =
        index === -1
          ? [...this.state.multipleQuestionsId, answerId]
          : [
              ...this.state.multipleQuestionsId.slice(0, index),
              ...this.state.multipleQuestionsId.slice(index + 1),
            ];

      this.setState({
        multipleQuestionsId: tempArray,
      });

      this.setState(prevState => ({
        multipleQuestions: {
          ...prevState.multipleQuestions,
          [id]: event.target.value,
        },
      }));
    }
  };

  generateTextField = (type, id) => {
    this.setState({
      generatedTextField: !this.state.generatedTextField,
    });
  };

  handleGeneratedTextField = (event, id) => {
    const value = event.target.value;
    this.setState({
      generatedTextValues: {
        [id]: value,
      },
    });
  };

  handleTextField = (event, id) => {
    const value = event.target.value;
    this.setState(prevState => ({
      textFieldValues: {
        ...prevState.textFieldValues,
        [id]: value,
      },
    }));
  };

  handleCountryChange = (event, id) => {
    const { value } = event.target;
    this.setState(prevState => ({
      textFieldValues: { ...prevState.textFieldValues, [id]: value },
    }));
  };

  calculateRemainingTime = (created, expiration) => {
    if (created && !expiration) return null;

    const now = moment();
    const mCreated = moment(created);
    const mExpiration = moment(expiration);

    const totalMinutes = mExpiration.diff(mCreated, 'minutes');
    const remainingMinutes = mExpiration.diff(now, 'minutes');

    const days = mExpiration.diff(now, 'days');
    const hours = mExpiration.subtract(days, 'days').diff(now, 'hours');
    const minutes = mExpiration.subtract(hours, 'hours').diff(now, 'minutes');

    if (days < 0 || minutes < 0 || hours < 0) {
      return 0;
    }

    return {
      time: `${days && days > 0 ? days + 'd' : ''} ${
        hours && hours > 0 ? hours + 'h' : ''
      } ${minutes && minutes > 0 ? minutes + 'm' : ''}`,
      percentage: 100 - Math.floor((100 * remainingMinutes) / totalMinutes),
    };
  };

  render() {
    if (this.state.viewState === 'loading') {
      return (
        <Container>
          <Loader isLoading={true} />
        </Container>
      );
    }

    const remainingTime = this.calculateRemainingTime(
      this.state.criteria.creatorInfo.dateCreated,
      this.state.criteria.expiration
    );
    const values = this.makeInitialValues(this.state.criteria);

    return (
      <Supply.Consumer>
        {({ fetchTickets }) => (
          <Formik
            enableReinitialize
            initialValues={values}
            onSubmit={this.onCreateSlip(fetchTickets)}
            validationSchema={makeSchema(values)}
          >
            {props => {
              let state = props.values;
              return (
                <Container>
                  {this.state.viewState === 'error' && (
                    <Error
                      onCancel={this.onErrorCancel}
                      onRetry={this.onRetry}
                      errors={this.state.errors}
                    />
                  )}
                  <ErrorNotification
                    message={
                      this.state.viewState === 'photo_size_error'
                        ? 'Image size cannot be greater then 5 MB'
                        : this.state.viewState === 'ies_size_error'
                        ? 'File size cannot be greater then 5 MB'
                        : this.state.viewState === 'spec_size_error'
                        ? 'Specifications files size cannot be greater then 5 MB'
                        : this.state.viewState === 'attach_size_error'
                        ? 'Attachment files size cannot be greater then 5 MB'
                        : null
                    }
                    open={
                      this.state.viewState &&
                      this.state.viewState.includes('size_error')
                    }
                    onCancel={this.onFileSizeErrorCancel}
                  />
                  <HeaderGrid container justify="space-between">
                    {this.state.criteria.hasDeletedSlip && (
                      <UpdateMsg>
                        The Requirements for this Luminaire Query have been
                        updated by the specifier. If you had previously
                        responded to this Query with a Luminaire, your Response
                        has been removed. Please resubmit, confirming your
                        Luminaire meets the updated Requirements.
                      </UpdateMsg>
                    )}
                    <Grid item xs={12} md={3}>
                      <TicketReference
                        iconCombination={this.state.criteria.ticketImageName}
                        name={this.state.criteria.referenceName}
                        locationOnPlan={this.state.locationOnPlan}
                        projectInfo={this.state.projectInfo}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {this.state.projectInfo && (
                        <CountryProject
                          country={this.state.projectInfo.projectCountry}
                          projectName={this.state.projectInfo.projectName}
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <IssuedBy
                        name={this.state.criteria.supplierContact.contact}
                        date={this.state.criteria.creatorInfo.dateCreated}
                      />
                    </Grid>
                  </HeaderGrid>
                  {this.renderCriteria(props)}
                  <PhotosAndNotes
                    assets={this.state.criteria.assets}
                    note={this.state.criteria.note}
                  />
                  {this.state.circularEconomy && (
                    <div>
                      <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-20">
                        Circular Economy Assessment
                      </h2>
                      <p className="t-primary-13 t-weight-b u-mrg-bot-3 c-red">
                        The specifier has required the following questions to be
                        answered with your response - response cannot be
                        submitted without answering these questions.
                      </p>
                    </div>
                  )}
                  {this.state.circularEconomy &&
                    this.state.circularEconomy.map(item => (
                      <Grid item className="u-pad-bot-30">
                        <Grid
                          item
                          className="t-primary-15 t-weight-b u-mrg-bot-3 u-mrg-top-20"
                        >
                          <em>{item.text}</em>
                        </Grid>
                        <Grid item>
                          {item.questions.map(question => (
                            <Grid container>
                              <Grid className="t-primary-13 t-weight-b u-mrg-bot-3 u-mrg-top-20 w50">
                                {question.text}
                              </Grid>
                              <Grid className="t-primary-13 u-mrg-left-100 u-mrg-top-10">
                                {question.questionType === 'PULL_DOWN_MENU' && (
                                  <SelectCustom
                                    className="menuItem"
                                    disableUnderline={true}
                                    value={
                                      this.state.menuQuestions[question.id]
                                    }
                                    onChange={event =>
                                      this.handleQuestions(
                                        event,
                                        question.id,
                                        'singleSelect'
                                      )
                                    }
                                    variant="outlined"
                                    defaultValue={
                                      this.state.menuQuestions[question.id]
                                    }
                                  >
                                    <MenuItem
                                      disabled
                                      className="menuItem"
                                      value={9999}
                                    >
                                      Not Set
                                    </MenuItem>
                                    {question.answers.map(answer => (
                                      <MenuItem
                                        className="menuItem"
                                        value={answer.id}
                                      >
                                        {answer.text}
                                      </MenuItem>
                                    ))}
                                  </SelectCustom>
                                )}
                                {question.questionType ===
                                  'PULL_DOWN_MENU_MULTISELECT' && (
                                  <div>
                                    <SelectCustom
                                      className="menuItem"
                                      style={{ maxWidth: '325px' }}
                                      multiple
                                      displayEmpty
                                      disableUnderline={true}
                                      value={Object.values(
                                        this.state.multipleQuestions[
                                          question.id
                                        ]
                                      )}
                                      name={question.id}
                                      onChange={event =>
                                        this.handleQuestions(
                                          event,
                                          question.id,
                                          'multipleSelect',
                                          event.currentTarget.getAttribute(
                                            'data-type'
                                          ),
                                          event.currentTarget.getAttribute(
                                            'data-id'
                                          )
                                        )
                                      }
                                      inputProps={{
                                        'aria-label': 'Without label',
                                      }}
                                      // input={<Input />}
                                      variant="outlined"
                                      renderValue={selected => {
                                        if (selected.length === 0) {
                                          return <p>Not Set</p>;
                                        }

                                        return selected.join(', ');
                                      }}
                                    >
                                      <MenuItem
                                        disabled
                                        className="menuItem"
                                        value={9999}
                                        data-name={'9999'}
                                      >
                                        Not Set
                                      </MenuItem>
                                      {question.answers.map(answer => (
                                        <MenuItem
                                          className="menuItem"
                                          key={answer.id}
                                          value={answer.text}
                                          data-type={answer.answerType}
                                          data-id={answer.id}
                                        >
                                          {answer.text}
                                        </MenuItem>
                                      ))}
                                    </SelectCustom>
                                    {this.state.generatedTextField && (
                                      <div>
                                        <TextField
                                          multiline
                                          fullWidth
                                          rowsMax={5}
                                          className="autoHeightComponent"
                                          value={
                                            this.state.generatedTextValues[10]
                                          }
                                          onChange={event =>
                                            this.handleGeneratedTextField(
                                              event,
                                              10
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                                {question.questionType === 'DIRECT' &&
                                  question.answers.map((answer, i) => {
                                    if (i === 0) {
                                      return (
                                        <Grid item>
                                          <FormControl>
                                            <InputLabel htmlFor="led-array">
                                              LED Array/engine
                                            </InputLabel>
                                            <Select
                                              // placeholder="LED Array/engine"
                                              style={{ maxWidth: '265px' }}
                                              native
                                              value={
                                                this.state.textFieldValues[
                                                  answer.id
                                                ]
                                              }
                                              onChange={e =>
                                                this.handleCountryChange(
                                                  e,
                                                  answer.id
                                                )
                                              }
                                              inputProps={{
                                                name: 'LED Array/engine',
                                                id: 'led-array',
                                              }}
                                            >
                                              <option value="" />
                                              {countries.map(c => (
                                                <option value={c}>{c}</option>
                                              ))}
                                            </Select>
                                          </FormControl>
                                        </Grid>
                                      );
                                    }
                                    if (i === 1) {
                                      return (
                                        <Grid item>
                                          <FormControl>
                                            <InputLabel htmlFor="driver-control">
                                              Driver/control gear
                                            </InputLabel>
                                            <Select
                                              style={{ maxWidth: '265px' }}
                                              native
                                              value={
                                                this.state.textFieldValues[
                                                  answer.id
                                                ]
                                              }
                                              onChange={e =>
                                                this.handleCountryChange(
                                                  e,
                                                  answer.id
                                                )
                                              }
                                              inputProps={{
                                                name: 'Driver/control gear',
                                                id: 'driver-control',
                                              }}
                                            >
                                              <option value="" />
                                              {countries.map(c => (
                                                <option value={c}>{c}</option>
                                              ))}
                                            </Select>
                                          </FormControl>
                                        </Grid>
                                      );
                                    }
                                    if (i === 2) {
                                      return (
                                        <Grid item>
                                          <FormControl>
                                            <InputLabel htmlFor="luminaire-assemlby">
                                              Luminaire assembly
                                            </InputLabel>
                                            <Select
                                              style={{ maxWidth: '265px' }}
                                              native
                                              value={
                                                this.state.textFieldValues[
                                                  answer.id
                                                ]
                                              }
                                              onChange={e =>
                                                this.handleCountryChange(
                                                  e,
                                                  answer.id
                                                )
                                              }
                                              inputProps={{
                                                name: 'Luminaire assembly',
                                                id: 'luminaire-assemlby',
                                              }}
                                            >
                                              <option value="" />
                                              {countries.map(c => (
                                                <option value={c}>{c}</option>
                                              ))}
                                            </Select>
                                          </FormControl>
                                        </Grid>
                                      );
                                    }
                                  })}
                              </Grid>
                            </Grid>
                          ))}
                        </Grid>
                        <Divider className="u-mrg-top-10 u-mrg-bot-10" />
                      </Grid>
                    ))}
                  {/* {this.renderSlipOptions(state) ? (
                    <React.Fragment> */}
                  <Grid container spacing={16}>
                    <Grid item xs={12} md={8}>
                      <AddPhoto
                        error={
                          (props.errors.photo || props.errors.photo1) &&
                          (props.touched.photo || props.touched.photo1)
                            ? props.errors.photo || props.errors.photo1
                            : null
                        }
                        onPhotoClear={this.onClearImage(props.setFieldValue)}
                        photoRef={this.photo}
                        photo1Ref={this.photo1}
                        photo={this.state.photo}
                        photo1={this.state.photo1}
                        onAddPhoto={this.onAddPhoto(props.setFieldValue)}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <NoteAndUrl
                        noteError={
                          props.errors.slipNote && props.touched.slipNote
                            ? props.errors.slipNote
                            : null
                        }
                        urlError={
                          props.errors.url && props.touched.url
                            ? props.errors.url
                            : null
                        }
                        onUrlAndNoteChange={this.onUrlAndNoteChange(
                          props.setFieldValue
                        )}
                        note={props.values.slipNote}
                        url={props.values.url}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={16} alignItems="stretch">
                    <Grid container spacing={16} alignItems="stretch">
                      <Grid item xs={12} md={6}>
                        <AddAttachment
                          error={
                            props.errors.specificationSheets &&
                            props.touched.specificationSheets
                              ? props.errors.specificationSheets
                              : null
                          }
                          onAttachmentRemove={this.onAttachmentRemove(
                            props.setFieldValue,
                            props.values
                          )}
                          onAddAttachment={this.onAddAttachment(
                            props.setFieldValue,
                            props.values
                          )}
                          attachmentFile1={props.values.attachmentFile1}
                          attachmentFile2={props.values.attachmentFile2}
                          attachmentFile3={props.values.attachmentFile3}
                          attachmentFile4={props.values.attachmentFile4}
                          attachmentFile5={props.values.attachmentFile5}
                          attachmentFile6={props.values.attachmentFile6}
                          attachmentFile7={props.values.attachmentFile7}
                          attachmentRef={this.attachmentRef}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <AddSpecifications
                          error={
                            props.errors.specificationSheets &&
                            props.touched.specificationSheets
                              ? props.errors.specificationSheets
                              : null
                          }
                          onSpecificationRemove={this.onSpecificationRemove(
                            props.setFieldValue,
                            props.values.specificationSheets
                          )}
                          onAddSpecification={this.onAddSpecification(
                            props.setFieldValue,
                            props.values.specificationSheets
                          )}
                          specificationSheets={props.values.specificationSheets}
                          specificationRef={this.specificationRef}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={16} alignItems="stretch">
                      <Grid item xs={12} md={6}>
                        <IESUpload
                          error={
                            props.errors.ies && props.touched.ies
                              ? props.errors.ies
                              : null
                          }
                          onIESFileRemove={this.onClearValue(
                            props.setFieldValue
                          )}
                          iesInputRef={this.iesInputRef}
                          ies={props.values.ies}
                          onAddIESFile={this.onAddIESFile(props.setFieldValue)}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <ContactDetails
                          details={this.state.criteria.supplierContact}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container spacing={16} alignItems="stretch">
                    <Grid item xs={12} md={4}>
                      <SendSlip onSubmit={props.handleSubmit} />
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <InfoText />
                    </Grid>
                  </Grid>
                </Container>
              );
            }}
          </Formik>
        )}
      </Supply.Consumer>
    );
  }
}

export default TicketView;
